/**
 * Application Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './components/ThemeProvider';
import { ToastProvider } from './components/shared';
import { QueryProvider } from './lib/QueryProvider';
import { initVitals } from './lib/vitals';
import { attemptChunkReloadOnce } from './lib/chunkReload';
import './index.css';

initVitals();

// Vite's own signal for a stale-deployment dynamic-import failure (a
// React.lazy() route whose chunk no longer exists after a new deploy
// replaced every content-hashed filename) — structural and
// browser-independent, unlike matching on error.message text. This is the
// primary defense; ErrorBoundary's message-pattern match is the fallback
// for failures that don't route through Vite's preload machinery.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  attemptChunkReloadOnce();
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryProvider>
      <ThemeProvider defaultTheme="system">
        <ToastProvider>
          <App />
        </ToastProvider>
      </ThemeProvider>
    </QueryProvider>
  </React.StrictMode>
);
